/* eslint-disable no-console */
const debug = {
  params: {
    debug: false
  },
  on: {
    pageBeforeIn(page) {
      if (this.params.debug)
        console.log('pageBeforeIn', page);
    },
    pageAfterIn(page) {
      if (this.params.debug)
        console.log('pageAfterIn', page);
    },
    pageBeforeOut(page) {
      if (this.params.debug)
        console.log('pageBeforeOut', page);
    },
    pageAfterOut(page) {
      if (this.params.debug)
        console.log('pageAfterOut', page);
    },
    pageInit(page) {
      if (this.params.debug)
        console.log('pageInit', page);
    },
    pageBeforeRemove(page) {
      if (this.params.debug)
        console.log('pageBeforeRemove', page);
    }
  }
};
/* eslint-enable no-console */
export default debug;
